<template>
  <modal
    name="campaign-welcome"
    :click-to-close="false"
    :adaptive="true"
    :scrollable="true"
    :pivot-y="0.2"
    :max-width="720"
    height="auto"
    width="90%"
    @closed="onModalClose"
  >
    <Button class="close-button" @click="$modal.hide('campaign-welcome')">
      <v-icon slot="icon-end" name="times" />
    </Button>

    <div class="content">
      <img class="intro-image" src="../../assets/icons/decorated/email.svg" />

      <h2 class="title">
        Welcome to your newsletter!
      </h2>

      <p class="intro">
        We’ve crafted this beautiful newsletter filled with the best content
        your site has to offer. If you want to make any changes you can use the
        editor to customise the layout and style.
      </p>

      <p class="intro">
        If you need any help, check out our
        <a
          href="http://help.promo.ai/category/newsletters-by-promo-ai/"
          target="_blank"
          class="font-bold"
        >
          Getting Started Guide
        </a>
        for some handy tips & tricks.
      </p>

      <p class="intro">
        And if you’re happy with the design, you can send it out right away.
      </p>

      <Button
        class="btn secondary mx-auto"
        @click="$modal.hide('campaign-welcome')"
      >
        Get Started
      </Button>
    </div>
  </modal>
</template>

<script>
export default {
  name: "WelcomeModal",

  methods: {
    onModalClose() {
      window.localStorage.setItem("pai-hideWelcomeModal", true);
    },
  },
};
</script>

<style scoped>
.content {
  @apply p-4 text-center max-w-md mx-auto;
}

.intro-image {
  @apply mx-auto block mt-8 mb-10;
}

.title {
  @apply text-support text-lg;

  @screen lg {
    @apply text-2xl;
  }
}

.intro {
  @apply font-light;
}
</style>
